import SwipeableCaseStudies from './SwipeableCaseStudies';

export default SwipeableCaseStudies;



// WEBPACK FOOTER //
// ./src/components/shared/SwipeableCaseStudies/index.js